/*

This is a visual only password page
form accepts passwords
also uses URL params to auto-fill the passowrd
and the Param "form" to show one of two forms "standard" or "VIP"


example URL:

https://www.philantropica.club/?pw=goals-club

Anything added in 'AUTO_ACCESS_KEYS' can then be used after the 'pw' parameter in the URL

*/

(() => {
  // Set to true during testing to always show the overlay.
  const FORCE_SHOW_FOR_TESTING = false;
  const MOCK_PASSWORDS = ['tropical', 'alfanero', 't', 'OBCommunity'];
  const AUTO_ACCESS_PARAM = 'pw';
  const AUTO_ACCESS_KEYS = ['ptctts', 'high-society', 'deutsche-bank', 'goals-club', 'magic-link', 'world-oceans-day', 'welcome', 'general', 'ptlaunch' ];
  const WEL_VERSION_PARAM = 'wel-version';
  const WEL_VERSION_CANNES = 'cannes';
  const AUTH_DOES_EXPIRE_KEY = 'authDoesExpire';
  const WHEN_DOES_EXPIRE_KEY = 'whenDoesExpire';
  const CANNE_AUTH_EXPIRES_AT = '1781697600';
  const EXP_PARAM = 'exp';
  const EXP_LINK_EXPIRED_CLASS = 'exp__link-has-expired';
  const DISMISSED_KEY = 'passwordOverlayDismissed';
  const DISMISSED_CLASS = 'password-overlay__dismissed';
  const AUTH_COUNTDOWN_SHOW_CLASS = 'auth-countdown__show';
  const PASSWORD_CORRECT_BODY_CLASS = 'password-overlay__correct';


  const overlay = document.querySelector('[data-password-overlay]');
  const authWillExpireButton = document.getElementById('auth-will-expire__button');
  const forms = overlay?.querySelectorAll('[data-password-form]') ?? [];
  const params = new URLSearchParams(window.location.search);
  const standardWrapper = overlay?.querySelector('.form__standard');
  const vipWrapper = overlay?.querySelector('.form-wrap__vip_one');
  const ENTRY_PARAMS = ['form', 'pw', 'wel-version'];
  const hasEntryParam = ENTRY_PARAMS.some((key) => params.has(key));
  let hideOverlayTimeoutId = null;

  if (!overlay || !forms.length) return;

  overlay.dataset.entryMode = hasEntryParam ? 'form' : 'signup';

  const hasBeenDismissed = () => {
    try {
      return window.sessionStorage.getItem(DISMISSED_KEY) === 'true';
    } catch (error) {
      return false;
    }
  };

  const markDismissed = () => {
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, 'true');
    } catch (error) {
      // Ignore storage errors; visual behavior still works.
    }

    document.documentElement.classList.add(DISMISSED_CLASS);
  };

  const clearDismissed = () => {
    try {
      window.sessionStorage.removeItem(DISMISSED_KEY);
    } catch (error) {
      // Ignore storage errors; visual behavior still works.
    }

    document.documentElement.classList.remove(DISMISSED_CLASS);
  };

  const setCanneExpiringAuth = () => {
    try {
      const existingExpiresAt = getWhenDoesExpireAt();
      const now = Math.floor(Date.now() / 1000);
      const hasValidFutureExpiry =
        Number.isFinite(existingExpiresAt) && existingExpiresAt > now;

      if (hasValidFutureExpiry) {
        window.localStorage.setItem(AUTH_DOES_EXPIRE_KEY, 'true');
        return;
      }

      window.localStorage.setItem(AUTH_DOES_EXPIRE_KEY, 'true');
      window.localStorage.setItem(WHEN_DOES_EXPIRE_KEY, CANNE_AUTH_EXPIRES_AT);
    } catch (error) {
      // Ignore storage errors; expiry behavior falls back to non-expiring auth.
    }
  };

  const storeExpFromParam = () => {
    try {
      const rawExp = params.get(EXP_PARAM);
      if (!rawExp) return;

      const expiresAt = Number.parseInt(rawExp, 10);
      if (!Number.isFinite(expiresAt) || expiresAt <= 0) return;

      // A new exp in the URL always replaces any previously stored value.
      window.localStorage.setItem(AUTH_DOES_EXPIRE_KEY, 'true');
      window.localStorage.setItem(WHEN_DOES_EXPIRE_KEY, String(expiresAt));
    } catch (error) {
      // Ignore storage errors; falls back to non-expiring auth.
    }
  };

  const getWhenDoesExpireAt = () => {
    try {
      const expiresAt = Number.parseInt(
        window.localStorage.getItem(WHEN_DOES_EXPIRE_KEY),
        10
      );

      return Number.isFinite(expiresAt) ? expiresAt : null;
    } catch (error) {
      return null;
    }
  };

  const getAuthTimeRemainingParts = () => {
    const expiresAt = getWhenDoesExpireAt();
    if (expiresAt === null) {
      return null;
    }

    const secondsUntilExpiry = Math.max(0, expiresAt - Math.floor(Date.now() / 1000));

    return {
      days: Math.floor(secondsUntilExpiry / 86400),
      hours: Math.floor((secondsUntilExpiry % 86400) / 3600),
      mins: Math.floor((secondsUntilExpiry % 3600) / 60),
      seconds: secondsUntilExpiry % 60,
    };
  };

  const formatAuthTimeRemaining = ({ days, hours, mins, seconds }) =>
    `${days} Days, ${hours} Hours, ${mins} Minutes, ${seconds} Seconds`;

  const logCanneAuthExpiresAtAsTimeParts = () => {
    try {
      const timeParts = getAuthTimeRemainingParts();
      if (!timeParts) {
        return;
      }

      console.log('CANNE_AUTH_EXPIRES_AT countdown:', timeParts);
    } catch (error) {
      // Ignore storage errors; this is only for debug logging.
    }
  };

  const isAuthCountdownActive = () => {
    try {
      if (window.localStorage.getItem(AUTH_DOES_EXPIRE_KEY) !== 'true') {
        return false;
      }

      const expiresAt = getWhenDoesExpireAt();
      if (expiresAt === null) {
        return false;
      }

      return Math.floor(Date.now() / 1000) < expiresAt;
    } catch (error) {
      return false;
    }
  };

  const syncAuthCountdownBodyClass = () => {
    const authCountdownActive = isAuthCountdownActive();
    const authExpired = hasAuthExpired();

    document.body.classList.toggle(
      AUTH_COUNTDOWN_SHOW_CLASS,
      authCountdownActive || authExpired
    );
    document.body.classList.toggle('auth__has-expired', authExpired);
  };

  const syncPasswordCorrectBodyClass = () => {
    document.body.classList.toggle(
      PASSWORD_CORRECT_BODY_CLASS,
      overlay.dataset.passwordCorrect === 'true'
    );
  };



  const updateAuthCountdownText = () => {
    const timeParts = getAuthTimeRemainingParts();
    if (!timeParts) {
      return;
    }

    const formatted = formatAuthTimeRemaining(timeParts);

    const countdownValue = document.querySelector('[data-auth-countdown-value]');
    if (countdownValue) {
      countdownValue.textContent = formatted;
    }

    const expTimeLeftValue = document.querySelector('#body__exp-time-left p');
    if (expTimeLeftValue) {
      expTimeLeftValue.textContent = `Link expires in: ${formatted}`;
    }
  };

  const initAuthCountdownTextTicker = () => {
    updateAuthCountdownText();

    if (hasAuthExpired()) {
      return;
    }

    const countdownIntervalId = window.setInterval(() => {
      updateAuthCountdownText();
      syncAuthCountdownBodyClass();

      if (!hasAuthExpired()) {
        return;
      }

      window.clearInterval(countdownIntervalId);
    }, 1000);
  };

  const hasAuthExpired = () => {
    try {
      if (window.localStorage.getItem(AUTH_DOES_EXPIRE_KEY) !== 'true') {
        return false;
      }

      const expiresAt = getWhenDoesExpireAt();
      if (expiresAt === null) {
        return false;
      }

      return Math.floor(Date.now() / 1000) >= expiresAt;
    } catch (error) {
      return false;
    }
  };

  if (params.get(WEL_VERSION_PARAM) === WEL_VERSION_CANNES) {
    setCanneExpiringAuth();
  }

  storeExpFromParam();

  logCanneAuthExpiresAtAsTimeParts();
  syncAuthCountdownBodyClass();
  syncPasswordCorrectBodyClass();
  initAuthCountdownTextTicker();

  const authExpired = hasAuthExpired();

  if (FORCE_SHOW_FOR_TESTING) {
    clearDismissed();
  } else if (authExpired) {
    clearDismissed();
  } else if (hasBeenDismissed()) {
    document.documentElement.classList.add(DISMISSED_CLASS);
    overlay.dataset.passwordCorrect = 'true';
    syncPasswordCorrectBodyClass();
    overlay.style.display = 'none';
    return;
  }

  const formEntries = Array.from(forms)
    .map((form) => {
      const input = form.querySelector('[data-password-input]');
      const wrapper = form.closest('.form__standard, .form-wrap__vip_one');

      if (!input || !wrapper) return null;

      return {
        form,
        input,
        wrapper,
      };
    })
    .filter(Boolean);

  if (!formEntries.length) return;

  const getFormEntryByType = (formType) => {
    if (formType === 'vip') {
      return formEntries.find((entry) => entry.wrapper.classList.contains('form-wrap__vip_one'));
    }

    return formEntries.find((entry) => entry.wrapper.classList.contains('form__standard'));
  };

  const revealForm = (formType) =>
    new Promise((resolve) => {
      const showVip = formType === 'vip';
      const wrapperToShow = showVip ? vipWrapper : standardWrapper;

      if (!wrapperToShow) {
        resolve(formType);
        return;
      }

      gsap.set(wrapperToShow, {
        display: 'block',
      });

      gsap.to(wrapperToShow, {
        delay: 0.6,
        opacity: 1,
        pointerEvents: 'auto',
        duration: 0.4,
        ease: 'power1.in',
        onComplete: () => resolve(formType),
      });
    });

  // Inputs render with `readonly` so mobile browsers (e.g. Chrome) don't
  // auto-open the keyboard on load or on programmatic focus. We drop
  // `readonly` on the first genuine pointer/touch so real taps still type.
  const enableInputOnInteraction = (input) => {
    const makeEditable = () => input.removeAttribute('readonly');

    input.addEventListener('pointerdown', makeEditable);
    input.addEventListener('touchstart', makeEditable, { passive: true });
    input.addEventListener('mousedown', makeEditable);
  };

  formEntries.forEach(({ form, input }) => {
    enableInputOnInteraction(input);

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const isCorrect = MOCK_PASSWORDS.includes(input.value);
      overlay.dataset.passwordCorrect = isCorrect ? 'true' : 'false';
      syncPasswordCorrectBodyClass();

      if (!isCorrect) {
        if (hideOverlayTimeoutId) {
          window.clearTimeout(hideOverlayTimeoutId);
          hideOverlayTimeoutId = null;
        }
        return;
      }

      markDismissed();
      input.blur();
      hideOverlayTimeoutId = window.setTimeout(() => {
        overlay.style.display = 'none';
        window.scrollTo(0, 0);
      }, 1700);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      form.requestSubmit();
    });
  });

  const loginButton = overlay.querySelector('.login-btn__flow');
  loginButton?.addEventListener('click', () => {
    overlay.dataset.entryMode = 'form';
    revealForm('standard');
  });

  const maybeRunAutoAccess = (activeFormEntry) => {
    const autoAccessParam = params.get(AUTO_ACCESS_PARAM);
    if (!AUTO_ACCESS_KEYS.includes(autoAccessParam) || !activeFormEntry) return;

    if (hasAuthExpired()) {
      document.body.classList.add(EXP_LINK_EXPIRED_CLASS);
      return;
    }

    const magicPassword = MOCK_PASSWORDS[0];
    let index = 0;
    const { form, input } = activeFormEntry;

    input.value = '';
    input.focus();

    const typeInterval = window.setInterval(() => {
      index += 1;
      input.value = magicPassword.slice(0, index);

      if (index < magicPassword.length) return;

      window.clearInterval(typeInterval);
      window.setTimeout(() => {
        form.requestSubmit();
      }, 1300);
    }, 500);
  };

  const init = async () => {
    if (!hasEntryParam) return;

    const formType = params.get('form') === 'vip' ? 'vip' : 'standard';
    await revealForm(formType);

    const activeFormEntry = getFormEntryByType(formType) ?? formEntries[0];
    maybeRunAutoAccess(activeFormEntry);
  };

  init();
})();
